<div class="page-body">
  <div *ngIf="loading">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loading && !error">
    <div class="banner">
      <button type="button" class="back-button" (click)="reroute()">
        <app-zaver-icon [size]="14" name="chevronLeft"></app-zaver-icon>
        <span class="back-text">Tillbaka</span>
      </button>
    </div>

    <div class="contents-wrapper">
      <div class="contents-container">
        <div class="page-icon">
          <app-zaver-icon [size]="80" name="invoiceCircle"></app-zaver-icon>
        </div>

        <div class="page-text">{{ headline }}</div>

        <div class="details">
          <hr class="details-divider" />
          <div class="details-container">
            <div class="details-key-entry">
              {{ paymentRequest.title }}
            </div>

            <zaver-button-link
              [text]="'Detaljer om ditt köp'"
              (click)="openDetailsModal()"
            ></zaver-button-link>
          </div>

          <hr class="details-divider" />
          <div class="details-container">
            <div class="details-key-entry">Totalbelopp</div>

            <div class="details-value-entry">
              {{
                paymentRequest.amount.toLocaleString('sv', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })
              }}
              SEK
            </div>
          </div>

          <hr class="details-divider" />
        </div>

        <div class="footer-wrapper">
          <div class="footer-container">
            <zaver-primary-button
              [text]="'Slutför köp'"
              [disabled]="navigationInProgress"
              (click)="handleCtaClick()"
              [logo]="'/assets/icon/BankID-Vector-Logo-White.svg'"
            ></zaver-primary-button>

            <div class="terms-row">
              <zaver-button-link
                [text]="'Visa villkor'"
                (click)="openInvoiceTerms()"
              >
              </zaver-button-link>

              <zaver-loading-dots
                *ngIf="showTermsSpinner"
                class="loading-dots"
                [color]="'#b7bcc8'"
              ></zaver-loading-dots>

              <div class="void-to-center-spinner"></div>
            </div>

            <div class="fallback-offer">
              {{ fallbackInfo }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<zaver-checkout-modal
  *ngIf="modalActive"
  [buttonText]="'Stäng'"
  [title]="'Visa detaljer'"
  (onClose)="deactivateModal()"
>
  <app-selector
    *ngIf="!!selectorItems"
    [selectorItems]="selectorItems"
    [selectedItem]="selectedItem"
  >
  </app-selector>
</zaver-checkout-modal>
